export default "__VITE_ASSET__0f89e49a__"